import { useContext } from "react";
import { TerminologyContext } from "@/contexts/TerminologyContext";

export const useTerminology = () => useContext(TerminologyContext);
